import { render, staticRenderFns } from "./PartnerListItem.vue?vue&type=template&id=23d0c787&scoped=true"
import script from "./PartnerListItem.vue?vue&type=script&lang=js"
export * from "./PartnerListItem.vue?vue&type=script&lang=js"
import style0 from "./PartnerListItem.vue?vue&type=style&index=0&id=23d0c787&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d0c787",
  null
  
)

export default component.exports